var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLeftMiddleBall(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 394,
    height: 502,
    viewBox: "0 0 394 502",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_1_72)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-21.0873 425.67C-117.137 334.221 -121.134 181.942 -30.0167 85.5437C61.101 -10.8541 212.83 -14.8664 308.879 76.582C404.928 168.03 408.926 320.31 317.808 416.708C226.691 513.106 74.9619 517.118 -21.0873 425.67Z",
    fill: "url(#paint0_radial_1_72)",
    fillOpacity: 0.9
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1_72",
    x: -105.823,
    y: 0.536499,
    width: 499.438,
    height: 501.179,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "effect1_foregroundBlur_1_72"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1_72",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(170.878 285.323) rotate(143.829) scale(237.801 238.064)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFABDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F66FC0"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftMiddleBall);
export default __webpack_public_path__ + "static/media/left-middle-ball.085a430b88b72f1fba37f6f8e4e18fd4.svg";
export { ForwardRef as ReactComponent };